module.exports = __webpack_public_path__ + "warta.png?bea3338a2b73ace31165115828e4879e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warta.png
// module id = 109
// module chunks = 0